module.exports = __webpack_public_path__ + "img/1473460202.e834b82c.jpg";